<div class="ai-chat-window flex-control flex-column" *ngIf="isOpen" [class.minimized]="isMinimized">
  <div class="chat-flex">
    <!--    Left Panel History Bar-->
    <div class="left-panel" [class.collapsed]="!isLeftPanelOpen">
      <div class="header mb-lg ">
        <div class="hamburger" (click)="toggleLeftPanel()" title="Toggle History Panel">
          <div class="pic-holder">
            <img class="favicon img-responsive" src="assets/img/branding/favicon.png" alt="WellWink">
          </div>
        </div>
        <div class="icon-sec" *ngIf="isLeftPanelOpen">
          <a class="btn btn-link-secondary" data-toggle="tooltip" data-placement="top" title="Search">
            <i class="fa fa-search fs16"></i>
          </a>
        </div>
      </div>
      <ng-container *ngIf="isLeftPanelOpen">
        <h4 class="mb-lg pl-10">Chats</h4>
        <ul class="user-list border-list m0 p0 scroll-browser">
          <ng-container>
            <li class="list active fs14">Create Care Plan... </li>
            <ng-container>
              <li class="list fs14">Recent patient alerts... </li>
            </ng-container>
          </ng-container>
        </ul>
      </ng-container>

      <footer class="pl-10" *ngIf="isLeftPanelOpen">
        <a class="btn btn-secondary fs14" (click)="clearHistory()" *ngIf="messages.length > 0">
          <i class="fa fa-pencil-square-o fs16" [title]="'New Chat'"></i>New Chat
        </a>
      </footer>
      <footer style="transform: translateX(-16px)!important;"  *ngIf="!isLeftPanelOpen">
        <a class="btn btn-link-secondary" (click)="clearHistory()" *ngIf="messages.length > 0">
          <i class="fa fa-pencil-square-o fs25 p" [title]="'New Chat'"></i>
        </a>
      </footer>

    </div>
    <!--    Right Panel Ai Chat -->
    <div class="body-panel p-relative">
      <div class="right-panel">
        <!--       Header start-->
        <div class="header">
          <div class="pic-name-sec">
            <div class="flex-grow flex-control flex-column">
              <div class="pic-holder pointer mb-lg mt-lg">
                <img class="ai-logo  img-responsive" src="assets/img/branding/wellwink-ai-logo.png" alt="WellWink">
              </div>
              <app-suggested-prompts class="mt-lg"
                                     (promptSelected)="useSuggestedPrompt($event)"></app-suggested-prompts>
            </div>
          </div>
          <div class="icon-sec">
            <!--           <a class="btn btn-default">-->
            <!--               <i class="fa fa-paperclip" [title]="'Upload File'"></i>-->
            <!--             </a>-->
            <button class="btn btn-default" (click)="close()" title="Close" aria-label="Close chat">
              <i class="fa fa-close" [title]="'Close Chat'"></i>
            </button>
          </div>
        </div>

        <!--       Header ending-->

        <!-- Messages Container -->
        <div class="chat-thread scroll-browser messages-container" #messagesContainer>
          <div class="chat-messages scroll-browser" *ngIf="!isMinimized">


            <h2 class="m0 text-center">Welcome to Alera, a healthcare AI assistant.</h2>
            <p class="fs16 text-center"> Designed to support care coordination, patient engagement, and everyday health needs.</p>


            <div *ngFor="let message of messages" class="message-wrapper" [class]="'message-' + message.type">

              <div *ngIf="message.type === 'user'" class="float-left">
                <i class="fa fa-pencil fs14 pl-10" title="Edit message"></i>
                <i class="fa fa-copy fs14 pl-10 pr-10 pointer" (click)="copyMessage(message)" title="Copy message"></i>
              </div>
              <div class="message-bubble">
                <div class="message-content" [innerHTML]="parseMarkdown(message.content)"></div>
                <div class="message-timestamp">{{ formatTimestamp(message.timestamp) }}</div>
              </div>
              <div *ngIf="message.type !== 'user'" class="d-inline-flex">
                <i class="fa fa-thumbs-o-up fs14 pl-10 pointer mr" aria-hidden="true" title="Like"></i>
                <i class="fa fa-thumbs-o-down fs14 pl-10 pointer mr"  aria-hidden="true" title="Dislike"></i>
                <i class="fa fa-copy fs14 pl-10 pointer mr" (click)="copyMessage(message)" aria-hidden="true" title="Copy message"></i>
                <i class="fa fa-repeat fs14 pl-10 pointer mr" aria-hidden="true" title="Retry"></i>
                <i class="fa fa-ellipsis-v fs14 pl-10 pointer mr" aria-hidden="true" title="More Options"></i>
              </div>
            </div>

            <!-- Loading indicator -->
            <div class="message-wrapper message-ai" *ngIf="isLoading">
              <div class="message-bubble">
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div class="empty-state" *ngIf="messages.length === 0 && !isLoading">
              <div class="empty-icon"><i class="fa fa-comment text-primary"></i></div>
              <div class="empty-text fs16">Start a conversation with your AI assistant</div>
            </div>
          </div>
        </div>

        <!-- Input Section -->
        <div class="chat-input-section" *ngIf="!isMinimized">

          <!-- Input Area -->
          <div class="chat-input-container">
            <div class="textarea-container">
              <textarea #messageInput [(ngModel)]="currentMessage" class="form-control scroll-browser fs14" (keypress)="onKeyPress($event)"
                        placeholder="Ask me anything about patient care..." rows="1" [maxlength]="1000"
                        [class.error]="isMessageTooLong"></textarea>
              <button type="button" class="speak-btn btn btn-link-secondary " title="Speak">
                <i class="fa fa-microphone fs20"></i>
              </button>
            </div>
            <button type="submit" class="send-button btn btn-link-secondary" (click)="sendMessage()"
                    [disabled]="!currentMessage.trim() || isLoading || isMessageTooLong" aria-label="Send message">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path
                  d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
              </svg>
            </button>
          </div>
          <div class="input-footer">
            <span class="character-count" [class.warning]="characterCount > 900">
              {{ characterCount }}/1000
            </span>
            <small class="text-gray-dark pl-sm">
              General health info only—always consult a medical professional.</small>
            <button class="clear-button btn-link-secondary" (click)="clearHistory()" *ngIf="messages.length > 0">
              Clear History
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
